var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE_https_fasttrack_monolith_staging_demo_lsqlabs_com_remoteEntry_mjs_f50c4ef2__;